{
  "loggedOut": "Logged Out",
  "logOutDescription": "You've been logged out of ATB, however you may still be logged in to your",
  "identityProvider": "single sign-on identity provider",
  "logBackIn": "Didn't mean to log out? Log back in again.",
  "login": "Login"
}
